import { constants, typographyStyles } from "@newsela/angelou";

import { greyDarkWithOpacityHex } from "@/angelouCE/utils/constants";

const { ui } = constants.colors;
const coreBlue = ui.core[700];
const grey = ui.neutral[500];
const neutral100 = ui.neutral[100];
const neutral200 = ui.neutral[200];
const neutral400 = ui.neutral[400];
const greyDark = ui.neutral[700];
const white = ui.white[500];

const { textSObj } = typographyStyles;

const sharedFlexCss = {
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
};

export const sharedButtonCss = (isActive = false) => ({
  ...textSObj,
  ...sharedFlexCss,
  background: isActive ? coreBlue : white,
  border: "none",
  color: isActive ? white : grey,
  height: "32px",
  width: "32px",
  gap: 0,
  borderRadius: "4px",
  borderBottom: "0",
  padding: "4px",
  "> span": {
    "font-size": 0,
  },

  svg: {
    height: "25px",
    width: "25px",
  },

  ":hover, :focus-visible": {
    background: isActive ? coreBlue : greyDarkWithOpacityHex,
    color: isActive ? white : greyDark,
  },

  '&[aria-expanded="true"]': {
    background: coreBlue,
    color: white,
  },

  "&[disabled], :hover[disabled]": {
    opacity: 1,
    background: white,
  },
});

// Styles specific to popout buttons

export const popoutButtonWrapperCss = {
  width: "100%",
};

export const popoutButtonCss = {
  ...sharedButtonCss(),

  span: {
    paddingRight: 0,
  },

  // The outline is several pixels inside the button
  // without this style
  "&:focus-visible": {
    outlineOffset: "-1px",
  },
};

export const popOutButtonContentsCss = {
  ...sharedFlexCss,

  "& span": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },

  "& span > svg": {
    width: "12px",
    height: "12px",
    marginRight: "5px",

    path: {
      strokeWidth: "3px",
    },

    circle: {
      strokeWidth: "3px",
    },
  },
};

// Styles for all buttons without a popout
// (except save, which is styled by `sharedButtonCss`)

export const secondaryActionButtonCss = (isActive) => [
  {
    ...sharedButtonCss(isActive),
  },
];

export const unavailableButtonCss = [
  {
    ...sharedButtonCss(false),
    color: neutral200,
    ":hover, :focus-visible": {
      background: greyDarkWithOpacityHex,
      color: neutral200,
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "-2%",
      top: "48%",
      width: "102%",
      height: "0%",
      borderTop: `1px solid ${neutral400}`,
      borderBottom: `1px solid ${neutral400}`,
      transform: "rotate(-45deg)",
      borderRadius: "2px",
    },
  },
];

export const disabledSecondaryActionsCss = {
  ...sharedButtonCss(),
  color: neutral200,
  ":hover, :focus-visible": {
    color: neutral200,
  },
};
export const disabledButtonWithPopOutCss = {
  ...popoutButtonCss,
  ...disabledSecondaryActionsCss,
};

export const tooltipCss = {
  dialog: {
    root: {
      maxWidth: "fit-content",
      backgroundColor: neutral100,
      div: {
        lineHeight: 0,
      },

      "&:last-of-type div": {
        "&::before": {
          borderTopColor: neutral100,
          borderLeftColor: neutral100,
          backgroundColor: neutral100,
        },
      },
    },
    Button: {
      root: {
        svg: {
          width: "16px",
          height: "16px",
        },
      },
    },
  },
};
